export default {
    products:[],
    product:{relaciones:{categoria:{}}},
    pagination:{
        total:0,
        current_page:0,
    },
}
